import React, { useContext } from 'react';
import MenuItem from '../menuitem/index'
import { IoLogOut } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import MenuContext from '../../contexts/menu';
import { IoHomeSharp, IoPerson } from 'react-icons/io5';
import { FaFileInvoice, FaFolderOpen, FaMapMarkedAlt, FaTable, FaUserClock } from 'react-icons/fa';
import { BsFillPeopleFill } from 'react-icons/bs';
import { CustumerContext } from '../../contexts/custumer';
import AuthContext from '../../contexts/auth';
import { useHistory } from 'react-router-dom';
import Text from '../text';

const allMenus = [
  { id: 0, label: 'Home', link: '/', icon: IoHomeSharp, idSar: 0 },
  { id: 1, label: 'Usuários', link: '/usuarios', icon: IoPerson, idSar: 0 },
  { id: 2, label: 'Rondas', link: '/rondas', icon: FaMapMarkedAlt, idSar: 19334 },
  { id: 3, label: 'Faturas e Boletos', link: '/financeiro', icon: FaFileInvoice, idSar: 19335 },
  { id: 4, label: 'Ponto', link: '/ponto', icon: FaUserClock, idSar: 19336 },
  { id: 5, label: 'Funcionários', link: '/funcionarios', icon: BsFillPeopleFill, idSar: 19337 },
  { id: 6, label: 'Documentos', link: '/documentos', icon: FaFolderOpen, idSar: 19338 },
  { id: 7, label: 'Quadro de Vagas', link: '/quadro', icon: FaTable, idSar: 19339 }
];

const MobileAside: React.FC = () => {
  const { toggleMenu, currentPage, isOpen } = useContext(MenuContext);
  const { signOut, isMasterUser } = useContext(AuthContext);
  const { deleteList } = useContext(CustumerContext);
  const history = useHistory();
  const _isMaster = isMasterUser();

  function logOff() {
    signOut();
    deleteList();
    history.push("/");
  }

  return (
    <div
      className={`
    fixed inset-0 z-[1000] bg-gray-800
    transition-all duration-500 ease-out
    transform
    ${isOpen
          ? "translate-y-0 opacity-100"
          : "-translate-y-full opacity-0 pointer-events-none"}
  `}
    >
      <nav className='w-full h-full  bg-gray-800'>
        <div className='w-full flex justify-end mb-6'>
          <button className='p-3.5 bg-transparent border-0 cursor-pointer' onClick={toggleMenu}>
            <IoMdClose size={30} color={"#C3CAD9"} />
          </button>
        </div>
        <ul className="px-[20px]">
          {allMenus.map((item) => {
            if (item.id === 2 && !_isMaster) return null;

            return (
              <MenuItem
                key={item.id}
                label={item.label}
                link={item.link}
                Icon={item.icon}
                isActive={currentPage === item.link}
                onClick={() => toggleMenu()}
              />
            );
          })}

          <div
            className=" absolute bottom-0 group transition-all w-fit flex items-center p-2.5 hover:bg-gray-500 mb-[14px] cursor-pointer gap-[14px] rounded-[8px]"
            onClick={logOff}
          >
            <IoLogOut size={19} className="text-[#C3CAD9]" />
            <Text className="!transition-all !text-[#828895] group-hover:!text-gray-50 !text-sm !font-medium">
              Sair
            </Text>
          </div>
        </ul>
      </nav>
    </div>
  )
}



export default MobileAside;